import Zoom from "../zoom";
import { setPopupButton } from "./zoomPopup";
import { handleMouseMoveZoom, handleZoomImageSources } from "./zoomUtilities";

// ============================================
// ======== Funções de eventos de zoom ========
// ============================================

// Função que aplica o zoom utilizando apenas css, recebe como parametros a imagem,
// ou container da imagem, e uma condição de zoom customizada, por padrão a condição usada
// é a Zoom.isZoomActive
export function toggleZoom(image, isZoomed = null) {
  if (!image) return;

  // Verifica se a image recebida é um elemento imagem e caso não seja busca por uma dentro do mesmo
  const zoomImageElement = image.tagName === 'IMG' ? image : image.querySelector('img'); 

  if (!zoomImageElement) return; 

  // Define a condição que será usada pra definir o estado do zoom 
  // Caso não possua uma condição passada como parâmetro, ira utilizar a propriedade
  // isZoomActive do objeto Zoom
  let activeZoom = isZoomed != null ? isZoomed : Zoom.isZoomActive;


  // Define a ação de controle de classes e scale do zoom
  const classAction = activeZoom ? 'remove' : 'add';
  const scaleFactor = activeZoom ? 1 : Zoom.zoomFactor;

  

  // Faz a troca de estado de zoom na condição utilizada
  if (isZoomed == null) Zoom.isZoomActive = !activeZoom;

  // Estilos de zoom
  zoomImageElement.style.transform = `scale(${scaleFactor})`;
  image.classList[classAction]('-zoomed');

  handleZoomImageSources(zoomImageElement);

}

// Aplica as funções de evento para mouseenter e mouseleave do zoom
function handleHoverEvents(image, gallery) {
  if (!image || !gallery) return;
  const { zoomOnClick, zoomOnHover } = Zoom;

  if (zoomOnHover && !zoomOnClick) {
    // Zoom in quando o hover na imagem acontece
    image.addEventListener('mouseenter', (event) => {
      Zoom.mouseBehaviorTimeControl = Date.now();
      toggleZoom(image);
    });
  }

  if (zoomOnHover || zoomOnClick) {
    // Zoom out quando o mouse sai da imagem
    image.addEventListener('mouseleave', () => {
      Zoom.isZoomActive && toggleZoom(image);
    });
  }
}

// Adiciona os eventos de zoom na imagem com base nos parâmetros do objeto
export function addZoomEvents(image, gallery) {
  if (!image || !gallery) return;

  const {
    zoomOnClick,
    zoomOnHover,
  } = Zoom;

  // Adiciona classe com estilos que apontam disponibilidade do zoom
  if (zoomOnClick || zoomOnHover) {
    !image.hasAttribute('data-main-video') && image.classList.add('-zoom-available');
  }

  if (zoomOnHover && !zoomOnClick) image.closest('[data-main-slider]').classList.add('-hover-zoom'); 
  if (zoomOnClick && !zoomOnHover) image.closest('[data-main-slider]').classList.add('-single-click');
  if (zoomOnClick && zoomOnHover) image.closest('[data-main-slider]').classList.add('-single-click');

  const zoomContainer = image.querySelector('.swiper-zoom-container');
  const zoomedImage = image.querySelector('.swiper-zoom-target');

  // Tratamento de clique para aplicar e remover zoom ou exibir o popup
  if (zoomOnClick || zoomOnHover ) {
    image.addEventListener('click', (event) => {
      if (event.target.closest('[data-zoom-image]')) return; // Sai se o clique for no botão de zoom
      if (Zoom.mouseBehaviorTimeControl !== 0) {
        const currentTime = Date.now();
        const timeSinceMouseBehavior = currentTime - Zoom.mouseBehaviorTimeControl;

        // Se o clique veio muito logo após o mouseenter, ignorar
        if (timeSinceMouseBehavior < 200) return;
      }
      // Habilita ou desabilita o zoom no click ou hover dependendo do estado atual da imagem
      // Executa a função que aplica o transform origin correto para o scale do zoom
      if (zoomContainer && zoomedImage) handleMouseMoveZoom(event, zoomContainer, zoomedImage);
      toggleZoom(image);
      
    });
  }
  
  handleHoverEvents(image, gallery);
  setPopupButton(image);
}
